/* eslint-disable no-console,no-undef, camelcase */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
// import _ from "lodash";
import { editFitnessVideo, getFitnessVideoById, getVideosCategory } from '../../redux/actions';
import { muscleGroup, EditFitnessVideos, fitnessLevel } from '../../../mockData';
// import Waiting from '../Waiting';
import EditFitnessvideoForm from '../FormAddVideo/EditFitnessVideoForm';

const stateForEdit = {
  title: "",
  video_category_id: undefined,
  video_url: "",
  fitness_level: "none",
  muscle_group: "none",
  themeName: '',
  themeMonth: '',
  themeId: null,
  selectedOption: 0,
  video_categories: [], 
  description: "",
  imgSrc: "",
  selectedWellnessGoal: null,
  selectedQuestionId: null,
};

class EditFitnessVideo extends Component {

  constructor() {
    super();
    this.state = {
      editData: { ...stateForEdit }
    }
  }

  componentDidMount() {
    const { /*location: { pathname }, fetchFitnessVideoById,*/ getVideosCategory } = this.props;
    // const StringArray = pathname.split('/');
    getVideosCategory();
    // fetchFitnessVideoById(StringArray[(StringArray.length - 1)]);
  }

  componentDidUpdate(prevProps) {
    if (this.props.fitnessVideo !== prevProps.fitnessVideo) {
      if (this.props.fitnessVideo && this.props.fitnessVideo.length > 0) {
        this.setEditData(this.props.fitnessVideo[0]);
      }
    }
  }

  setEditData = (responseData) => {
    const { themesHeaderAll } = this.props;
    let newEditState = { ...stateForEdit };

    // Handle nested API structure
    const editFitnessData = responseData.video_details || responseData; 

    if (editFitnessData) {
      newEditState.title = editFitnessData.title || editFitnessData.video_title;
      newEditState.description = editFitnessData.description || "";
      newEditState.video_category_id = editFitnessData.wellness_category_id;
      newEditState.video_categories = this.setCategoryId(editFitnessData.video_categories);
      newEditState.video_url = editFitnessData.video_url;
      newEditState.themeId = editFitnessData.theme_id;
      newEditState.imgSrc = editFitnessData?.thumbnail_image;

      let findThemeIndex = -1;
      if (themesHeaderAll) {
        findThemeIndex = themesHeaderAll.findIndex((v) => v.id === newEditState.themeId);
        newEditState.themeName = findThemeIndex !== -1 ? themesHeaderAll[findThemeIndex].theme_text : '';
        newEditState.themeMonth = findThemeIndex !== -1 ? themesHeaderAll[findThemeIndex].month : '';
      }
      newEditState.selectedOption = findThemeIndex !== -1 ? 1 : 0;

      // Fitness Level Mapping
      if (editFitnessData.fitness_level === "Advanced") {
        newEditState.fitness_level = 3;
      } else if (editFitnessData.fitness_level === "Beginner") {
        newEditState.fitness_level = 1;
      } else if (editFitnessData.fitness_level === "Intermediate") {
        newEditState.fitness_level = 2;
      } else {
        newEditState.fitness_level = "none";
      }

      // Muscle Group Mapping
      const muscleMap = {
        "Back": 1, "Core": 2, "Hips": 3, "Legs": 4, "Shoulder": 5,
        "Chest": 6, "Arms": 7, "Upper Body": 8, "Lower Body": 9,
        "Total Body": 10, "Mindfulness": 11, "Mental Health": 12
      };
      newEditState.muscle_group = muscleMap[editFitnessData.muscle_group] || "none";

      newEditState.selectedWellnessGoal = editFitnessData.wellness_goal_id;
      newEditState.selectedQuestionId = editFitnessData.question_id;
    }

    this.setState({ editData: newEditState });
  }

  setCategoryId = (categoryTags) => {
    let arr = [];
    if (categoryTags && Array.isArray(categoryTags)) {
      categoryTags?.forEach((data) => {
        if(data && data.id) arr.push(data.id);
      });
    }
    return arr;
  };

  onSubmit = async (e, data,route) => {
    const { editFitnessVideos, history, fitnessVideo } = this.props;
    e.preventDefault();

    const editedVideo = { ...data };

    // Reverse Mapping for API
    if (data.fitness_level === 1) editedVideo.fitness_level = "Beginner";
    else if (data.fitness_level === 2) editedVideo.fitness_level = "Intermediate";
    else if (data.fitness_level === 3) editedVideo.fitness_level = "Advanced";
    else editedVideo.fitness_level = "none";

    const muscleMapReverse = {
      1: "Back", 2: "Core", 3: "Hips", 4: "Legs", 5: "Shoulder",
      6: "Chest", 7: "Arms", 8: "Upper Body", 9: "Lower Body",
      10: "Total Body", 11: "Mindfulness", 12: "Mental Health"
    };
    editedVideo.muscle_group = muscleMapReverse[data.muscle_group] || "none";

    // Set ID from nested video_details
    if (fitnessVideo && fitnessVideo.length > 0 && fitnessVideo[0].video_details) {
      editedVideo.id = fitnessVideo[0].video_details.id;
    }

    editedVideo.theme_id = data.themeId;
    editedVideo.wellness_goal_id = data.selectedWellnessGoal;
    editedVideo.question_id = data.selectedQuestionId;
    editedVideo.thumbnail_image = data.imgSrc ? data.imgSrc : null;

    // Cleanup state fields
    delete editedVideo.themeId;
    delete editedVideo.selectedWellnessGoal;
    delete editedVideo.selectedQuestionId;
    delete editedVideo.imgSrc;
    delete editedVideo.wbaQuestions;
    delete editedVideo.wellnessGoals;
    delete editedVideo.step;
    delete editedVideo.video_categories_obj;
    delete editedVideo.themeName;
    delete editedVideo.themeMonth;
    delete editedVideo.urlValid;
    delete editedVideo.charCount;
    delete editedVideo.showWbaQue;
    delete editedVideo.isLoadingQuestions;
    delete editedVideo.themeOpen;
    delete editedVideo.goalOpen;
    delete editedVideo.questionOpen;
    delete editedVideo.muscleGroupOpen;
    delete editedVideo.fitnessLevelOpen;

    // --- REDIRECT LOGIC ---
    // We await the action (assuming it returns a promise) and then go back.
    // We pass 'history' just in case the action requires it, but we force goBack here.
    try {
      await editFitnessVideos(editedVideo, history);
      if (route) {
        history.push(
          "/company/wellness",
          { activeTab: "Library", activeLibraryTab: "Fitness" }
        );
      } else {
        history.goBack(); // Redirect to previous page
      }
      // history.goBack(); // Redirect to previous page
    } catch (error) {
      console.error("Error updating video:", error);
      // Optional: Handle error (toast is usually handled in action)
    }
  };

  render() {
    const { videoLibraries, /*isLoading, fitnessVideo,*/ themesHeaderAll } = this.props;

    // if (isLoading || _.isEmpty(fitnessVideo)) {
    //   return <Waiting />
    // }

    return (
      <EditFitnessvideoForm
        buttonText={EditFitnessVideos.button}
        state={this.state.editData}
        video_category_id={videoLibraries}
        muscle_group={muscleGroup}
        fitness_level={fitnessLevel}
        onSubmit={this.onSubmit}
        themesHeaderAll={themesHeaderAll}
        history={this.props.history}
      />
    )
  }
}

EditFitnessVideo.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  videoLibraries: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  editFitnessVideos: PropTypes.func,
  themesHeaderAll: PropTypes.array,
  fitnessVideo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  t: PropTypes.func,
  fetchFitnessVideoById: PropTypes.func.isRequired,
  getVideosCategory: PropTypes.func
};

const mapStateToProps = (state) => ({
  isLoading: state.education.isLoading,
  fitnessVideo: state.education.fitnessVideo,
  videoLibraries: state.education.videoLibraries
});

const mapDispatchToProps = (dispatch) => ({
  editFitnessVideos: (data, history) => dispatch(editFitnessVideo(data, history)),
  fetchFitnessVideoById: (id) => dispatch(getFitnessVideoById(id)),
  getVideosCategory: () => dispatch(getVideosCategory())
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EditFitnessVideo)));